import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Duppala Chennakesava</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} DcK</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Duppala-Chennakesava"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            {/* 
<li className="social-icons">
  <a
    href=""
    target="_blank"
    rel="noopener noreferrer"
    className="icon-colour home-social-icons"
  >
    <AiOutlineTwitter />
  </a>
</li> 
*/}

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/duppala-chennakesava-2826aa250"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/its_me__chennu?igsh=bjZieWpydW1maXJo"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
